import React from 'react';
import { useParams } from 'react-router-dom';
import DirectDebitItem from '../presentational/DirectDebitItem';
import { useDispatch } from 'react-redux';
import { hideModal, showModal } from 'actions/modal';
import { ERROR_MODAL, CONFIRM_MODAL } from 'constants/shared/modalTypes';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import { DirectDebit } from 'lib/type';
import {
    useCancelDirectDebitMutation,
    useGetDirectDebitsQuery,
} from 'lib/services';

const DirectDebitItemContainer = () => {
    const { id } = useParams() as { id: string };
    const dispatch = useDispatch();

    // TBD. No Direct Debit data handling
    const { data: directDebit } = useGetDirectDebitsQuery(undefined, {
        selectFromResult: ({ data }) => ({
            data:
                data?.find((dd: DirectDebit) => dd.id === id) ||
                ({} as DirectDebit),
        }),
    });

    const [cancelDirectDebit, { isLoading }] = useCancelDirectDebitMutation();

    const handleSubmitCancel = async () => {
        try {
            await cancelDirectDebit({ id }).unwrap();
            dispatch(hideModal());
        } catch (error) {
            console.error(error);
            dispatch(
                showModal({
                    type: ERROR_MODAL,
                    props: {
                        onClose: () => dispatch(hideModal()),
                    },
                }),
            );
        }
    };

    const showCancelModal = () => {
        dispatch(
            showModal({
                type: CONFIRM_MODAL,
                props: {
                    handleSubmit: handleSubmitCancel,
                    title: 'Cancel Direct Debit',
                    message:
                        'Are you sure you want to cancel this direct debit?',
                },
            }),
        );
    };
    return (
        <PageContainer>
            <SectionTitle
                title={directDebit.payeeName}
                backRoute={'/payments/direct-debit'}
            />
            <DataCheck
                isLoading={isLoading}
                data={directDebit}
                noDataMessage="You currently have no direct debits"
            >
                <DirectDebitItem
                    data={directDebit}
                    showCancelModal={showCancelModal}
                />
            </DataCheck>
        </PageContainer>
    );
};

export default DirectDebitItemContainer;
